import { FormConfigType } from "@/types/dynamicForm";

const ProviderInvoiceFormConfig: FormConfigType = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "text",
                        "name": "reference_number",
                        "label": "Numero Referencia",
                        "isHorizontal": true,
                        "visibilityHiddenIf": () => true, // by default this input is hidden, suscrption data make it visible
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                    },
                ],
            ]
        }
    ],
};


export default ProviderInvoiceFormConfig;